module.exports = __webpack_public_path__ + "img/newTip.8afcc9a0.png";